import { Box, Flex, Img } from '@chakra-ui/react';
import * as React from 'react';
import Separator from '../separator/separator';
import CustomTextLink from '../customTextLink/customTextLink';
import KnowledgeBaseIcon from './images/icon-knowledge.svg';
import VideoIcon from './images/icon-video.svg';
import TutorialIcon from './images/icon-tutorial.svg';
import InfographicIcon from './images/icon-infographic.svg';

export default function HeaderWithLine(props) {
  /*
   * props.text
   * props.link
   * props.linktext
   * props.icon
   * props.linecolor
   * */
  const text = props.text;
  const link = props.link;
  const staticIcons = {
    knowledgeBase: KnowledgeBaseIcon,
    video: VideoIcon,
    tutorial: TutorialIcon,
    infographic: InfographicIcon,
  };
  const staticIcon = props.staticicon ? staticIcons[props.staticicon] : null;
  const icon =
    props.icon && props.icon.ikonaKategorii
      ? props.icon.ikonaKategorii[process.env.GATSBY_IMG_SOURCE]
      : props?.icon
      ? props.icon[process.env.GATSBY_IMG_SOURCE]
      : null;
  const fontWeight = props.fontWeight ? props.fontWeight : 'semibold';
  const background = props.background ? props.background : '#FFF';

  return (
    <Flex
      position={'relative'}
      flexWrap={'wrap'}
      alignItems={'center'}
      mb={{ base: '40px', lg: '40px' }}
      justifyContent={{ base: 'space-between', lg: 'flex-start' }}
      {...props}
    >
      <Box
        as={'h3'}
        fontSize={{ base: '18px', lg: props.fontSize ? props.fontSize : '22px' }}
        fontWeight={fontWeight}
        background={background}
        mb={'0'}
        display={'flex'}
        zIndex={'1'}
        alignItems={'center'}
        pr={{ base: '10px', lg: '20px', xl: '30px' }}
      >
        {icon && (
          <Img
            src={icon}
            w={{ base: '36px', md: '43px', lg: '36px', xxl: '60px' }}
            mr={{ base: '10px', lg: '20px', xl: '30px' }}
            alt={text ?? 'ikona'}
            display={'inline-block'}
            filter={'brightness(0%)'}
          />
        )}
        {staticIcon && (
          <Box
            as={staticIcon}
            w={{ base: '36px', md: '43px', lg: '36px', xxl: '60px' }}
            mr={{ base: '10px', lg: '20px', xl: '30px' }}
            display={'inline-block'}
            filter={'brightness(0%)'}
          />
        )}
        {text}
      </Box>
      {link && (
        <Flex
          background={background}
          pr={{ base: '0', lg: '20px', xl: '30px' }}
          pl={{ base: '10px', lg: '0' }}
          alignItems={'center'}
        >
          <Separator
            h={'40px'}
            ml="0"
            display={{ base: 'none', lg: 'block' }}
            mr={{ base: '10px', lg: '20px', xl: '30px' }}
          />
          <CustomTextLink link={link} text={props.linktext} display={{ base: 'none', phablet: 'flex' }} />
        </Flex>
      )}
      <Box
        as={'span'}
        background={props.linecolor ? props.linecolor : '#DBE1EA'}
        w="100%"
        height={'1px'}
        zIndex={'-1'}
        display={{ base: 'block' }}
        position={'absolute'}
        top={'50%'}
      />
    </Flex>
  );
}
